import { Component, OnInit, ViewChildren, Inject, PLATFORM_ID } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { NeproseService } from 'src/app/services/neprose.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-change-phone',
  templateUrl: './change-phone.component.html',
  styleUrls: ['./change-phone.component.css']
})
export class ChangePhoneComponent implements OnInit {

  form: FormGroup

  phone: FormControl = new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)])

  formInput = ['input1', 'input2', 'input3', 'input4'];
  
  @ViewChildren('formRow') rows: any;

  showVerificationBox: boolean

  constructor( private authService: AuthService, private _notification: MatSnackBar, private router: Router, private _neproseService: NeproseService,
    @Inject(PLATFORM_ID) protected platformId: Object) {
    this.form = this.toFormGroup(this.formInput)
  }

  ngOnInit(): void {

  }

  changePhone(phone){
    this.authService.changePhoneNumber(phone).subscribe(data => {
      if(data.status){
        this.showVerificationBox = true
      }
    }, error => {
      if(error.error){
        if(error.error.message){
          this.openNotification(error.error.message)
        }
      }
    })
  }

  toFormGroup(elements) {
    const group: any = {};
    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
   }

  verifyUser(code){
    this._neproseService.verifyUserPhone(code).subscribe(data => {
      if(data.status){
        this.phone.reset()
        this.phone.clearValidators()
        this.openNotification('Phone number is verified!')
        this.showVerificationBox = false
      }
    }, error => {
      if(error.error){
        if(error.error.msg){
          this.openNotification(error.error.msg);
        }else if(error.error.message){
          this.openNotification(error.error.message);
        }
      }
    })
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  goToNextInput(event, index){
    if(isPlatformBrowser(this.platformId)){
      var value = event.target.value
      let pos = index;
      if (event.keyCode === 8 && event.which === 8) {
        pos = index - 1 ;
      }else {
        if(parseInt(value) || (parseInt(value) == 0)){
          pos = index + 1 ;
        }else{
          event.preventDefault()
        } 
      }
      if (pos > -1 && pos < this.formInput.length ) {
        this.rows._results[pos].nativeElement.focus();
      }
    } 
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  onSubmit() {
    var values = this.form.value
    var code = ''
    for(let key in values){
      code = code + values[key]
    }
    this.verifyUser(code)
  }

}
